import { ToastDesignTokens } from '@primeng/themes/types/toast';

export default {
    root: {
        width: '25rem',
        borderRadius: '{content.border.radius}',
        borderWidth: '0 0 0 0px',
        transitionDuration: '{transition.duration}'
    },
    icon: {
        size: '2rem'
    },
    content: {
        padding: '{overlay.popover.padding}',
        gap: '0.5rem'
    },
    text: {
        gap: '0.5rem'
    },
    summary: {
        fontWeight: '500',
        fontSize: '1rem'
    },
    detail: {
        fontWeight: '300', //changed by mazars
        fontSize: '1rem' //changed by mazars
    },
    closeButton: {
        width: '2rem',
        height: '2rem',
        borderRadius: '0',
        focusRing: {
            width: '{focus.ring.width}',
            style: '{focus.ring.style}',
            offset: '{focus.ring.offset}'
        }
    },
    closeIcon: {
        size: '1rem'
    },
    colorScheme: {
        light: {
            root: {
                blur: '1.5px'
            },
            info: {
                background: '#2196F3', //changed by mazars
                borderColor: '{blue.500}',
                color: '{surface.0}', //changed by mazars
                detailColor: '{surface.0}', //changed by mazars
                shadow: '{overlay.popover.shadow}',
                closeButton: {
                    hoverBackground: '{blue.100}',
                    focusRing: {
                        color: '{focus.ring.color}',
                        shadow: '0 0 0 0.2rem {blue.200}'
                    }
                }
            },
            success: {
                background: '#34BFA3', //changed by mazars
                borderColor: '{green.500}',
                color: '{surface.0}', //changed by mazars
                detailColor: '{surface.0}', //changed by mazars
                shadow: '{overlay.popover.shadow}',
                closeButton: {
                    hoverBackground: '{green.100}',
                    focusRing: {
                        color: '{focus.ring.color}',
                        shadow: '0 0 0 0.2rem {green.200}'
                    }
                }
            },
            warn: {
                background: '#fd7e14', //changed by mazars
                borderColor: '{yellow.500}',
                color: '{surface.0}', //changed by mazars
                detailColor: '{surface.0}', //changed by mazars
                shadow: '{overlay.popover.shadow}',
                closeButton: {
                    hoverBackground: '{yellow.100}',
                    focusRing: {
                        color: '{focus.ring.color}',
                        shadow: '0 0 0 0.2rem {yellow.200}'
                    }
                }
            },
            error: {
                background: '#dc3545', //changed by mazars
                borderColor: '{red.500}',
                color: '{surface.0}', //changed by mazars
                detailColor: '{surface.0}', //changed by mazars
                shadow: '{overlay.popover.shadow}',
                closeButton: {
                    hoverBackground: '{red.100}',
                    focusRing: {
                        color: '{focus.ring.color}',
                        shadow: '0 0 0 0.2rem {red.200}'
                    }
                }
            },
            secondary: {
                background: '{surface.100}',
                borderColor: '{surface.500}',
                color: '{surface.600}',
                detailColor: '{surface.700}',
                shadow: '{overlay.popover.shadow}',
                closeButton: {
                    hoverBackground: '{surface.200}',
                    focusRing: {
                        color: '{focus.ring.color}',
                        shadow: '0 0 0 0.2rem {surface.200}'
                    }
                }
            },
            contrast: {
                background: '{surface.900}',
                borderColor: '{primary.color}',
                color: '{surface.50}',
                detailColor: '{surface.0}',
                shadow: '{overlay.popover.shadow}',
                closeButton: {
                    hoverBackground: '{surface.800}',
                    focusRing: {
                        color: '{focus.ring.color}',
                        shadow: '0 0 0 0.2rem {surface.400}'
                    }
                }
            }
        },
        dark: {
            root: {
                blur: '10px'
            },
            info: {
                background: 'color-mix(in srgb, {blue.500}, transparent 84%)',
                borderColor: 'color-mix(in srgb, {blue.700}, transparent 64%)',
                color: '{blue.500}',
                detailColor: '{surface.0}',
                shadow: '{overlay.popover.shadow}',
                closeButton: {
                    hoverBackground: 'rgba(255, 255, 255, 0.05)',
                    focusRing: {
                        color: '{focus.ring.color}',
                        shadow: '0 0 0 0.2rem color-mix(in srgb, {blue.500}, transparent 80%)'
                    }
                }
            },
            success: {
                background: 'color-mix(in srgb, {green.500}, transparent 84%)',
                borderColor: 'color-mix(in srgb, {green.700}, transparent 64%)',
                color: '{green.500}',
                detailColor: '{surface.0}',
                shadow: '{overlay.popover.shadow}',
                closeButton: {
                    hoverBackground: 'rgba(255, 255, 255, 0.05)',
                    focusRing: {
                        color: '{focus.ring.color}',
                        shadow: '0 0 0 0.2rem color-mix(in srgb, {green.500}, transparent 80%)'
                    }
                }
            },
            warn: {
                background: 'color-mix(in srgb, {yellow.500}, transparent 84%)',
                borderColor: 'color-mix(in srgb, {yellow.700}, transparent 64%)',
                color: '{yellow.500}',
                detailColor: '{surface.0}',
                shadow: '{overlay.popover.shadow}',
                closeButton: {
                    hoverBackground: 'rgba(255, 255, 255, 0.05)',
                    focusRing: {
                        color: '{focus.ring.color}',
                        shadow: '0 0 0 0.2rem color-mix(in srgb, {yellow.500}, transparent 80%)'
                    }
                }
            },
            error: {
                background: 'color-mix(in srgb, {red.500}, transparent 84%)',
                borderColor: 'color-mix(in srgb, {red.700}, transparent 64%)',
                color: '{red.500}',
                detailColor: '{surface.0}',
                shadow: '{overlay.popover.shadow}',
                closeButton: {
                    hoverBackground: 'rgba(255, 255, 255, 0.05)',
                    focusRing: {
                        color: '{focus.ring.color}',
                        shadow: '0 0 0 0.2rem color-mix(in srgb, {red.500}, transparent 80%)'
                    }
                }
            },
            secondary: {
                background: '{surface.800}',
                borderColor: '{surface.700}',
                color: '{surface.300}',
                detailColor: '{surface.0}',
                shadow: '{overlay.popover.shadow}',
                closeButton: {
                    hoverBackground: '{surface.700}',
                    focusRing: {
                        color: '{focus.ring.color}',
                        shadow: '0 0 0 0.2rem color-mix(in srgb, {surface.300}, transparent 80%)'
                    }
                }
            },
            contrast: {
                background: '{surface.0}',
                borderColor: '{surface.100}',
                color: '{surface.950}',
                detailColor: '{surface.950}',
                shadow: '{overlay.popover.shadow}',
                closeButton: {
                    hoverBackground: '{surface.100}',
                    focusRing: {
                        color: '{focus.ring.color}',
                        shadow: '0 0 0 0.2rem color-mix(in srgb, {surface.950}, transparent 80%)'
                    }
                }
            }
        }
    },
    css: ({ dt }) => `
    .p-toast {
        opacity: 0.9;
    }
    .p-toast-message-content {
	    padding: 1rem;
    }   
    .p-toast-message-text {
        flex: 1 1 auto;
        margin: 0 0 0 1rem;
        display: block !important; 
    }
    .p-toast-detail {
        margin: 0.2rem 0 0 0 !important;
    }
    .p-toast-close-button {
        margin: 0;
        right: unset;
    }
    .p-toast-message-success .p-toast-close-button:hover {
        background: rgba(255, 255, 255, 0.5);
    }

    `,
} as ToastDesignTokens;
